import type React from 'react';
import { useCallback } from 'react';

import { Link } from '@change-corgi/core/react/router';
import { useTracking } from '@change-corgi/core/react/tracking';

export const SummaryByAI: React.FC = () => {
	const track = useTracking();

	const onClick = useCallback(() => {
		void track('dm_profile_summary_by_ai_learn_more_click');
	}, [track]);

	return (
		<div data-testid="dm-summary-by-ai-disclosure" className="text-typography-weak mt-10 mb-5 md:mt-14 md:mb-9">
			<p className="text-size-body-xs">
				Info sourced from public filings, verified media, and official campaign materials and summarized by AI.{' '}
				<Link
					to="https://help.change.vote/sources"
					target="_blank"
					rel="noopener noreferrer"
					data-qa="dm-summary-by-ai-learn-more-link"
					onClick={onClick}
					className="text-typography-interactive block no-underline md:inline"
				>
					Learn more →
				</Link>
			</p>
		</div>
	);
};
